{
  "0x030fd1cc": "E_OnlyAssetCanDeposit",
  "0x08e2ce17": "E_Unauthorized",
  "0x0a1d0efb": "E_LiquidationCoolOff",
  "0x0a4e9d0b": "E_ConfigAmountTooLargeToEncode",
  "0x0dc316c4": "E_MinYield",
  "0x0e7db831": "E_ViolatorLiquidityDeferred",
  "0x13790bf0": "E_ControllerDisabled",
  "0x2082e200": "E_EmptyError",
  "0x2c82283f": "E_FeeExceedsBPS",
  "0x304fad62": "E_InsufficientAssets",
  "0x34373fbc": "E_AccountLiquidity",
  "0x35a43994": "E_IRMUpdateUnauthorized",
  "0x370f9b38": "E_BadAddress",
  "0x3ac94a30": "E_ProxyMetadata",
  "0x3b77f101": "E_ExcessiveRepayAmount",
  "0x426073f2": "E_SupplyCapExceeded",
  "0x43855d0f": "E_NoLiability",
  "0x458cbc27": "E_LTVBorrow",
  "0x459f5f6e": "E_ZeroAddress",
  "0x4b800e46": "ERC2612InvalidSigner",
  "0x5274afe7": "SafeERC20FailedOperation",
  "0x5b923371": "E_NoPriceOracle",
  "0x6081f51b": "E_ZeroAssets",
  "0x62791302": "ERC2612ExpiredSignature",
  "0x64e06479": "E_AmountTooLargeToEncode",
  "0x6d588708": "E_NotController",
  "0x6ef90ef1": "E_BorrowCapExceeded",
  "0x70ba0d81": "E_Initialized",
  "0x73748093": "E_InsufficientBalance",
  "0x74f36063": "E_Reentrancy",
  "0x750f8817": "E_OperationDisabled",
  "0x752d88c0": "InvalidAccountNonce",
  "0x8133abd1": "EVC_InvalidAddress",
  "0x89563211": "E_InvalidLTVAsset",
  "0x9388c334": "E_DebtAmountTooLargeToEncode",
  "0x94280d62": "ERC20InvalidSpender",
  "0x94d8be99": "E_SelfLiquidation",
  "0x9773bb71": "E_TransferFromFailed",
  "0x96c6fd1e": "ERC20InvalidSender",
  "0x98d6fe33": "E_FlashLoanNotRepaid",
  "0x9996b315": "AddressEmptyCode",
  "0x9af486d3": "E_BadBorrowCap",
  "0x9b314d55": "E_BadCollateral",
  "0x9b441636": "E_BadSharesOwner",
  "0x9b559a75": "E_CollateralDisabled",
  "0x9f428ac4": "E_InsufficientAllowance",
  "0xa8af73b4": "E_BadSharesReceiver",
  "0xaa19a73d": "E_BadMaxLiquidationDiscount",
  "0xae321632": "E_TransientState",
  "0xaeb1b8c6": "E_BadSupplyCap",
  "0xb2be531b": "E_RepayTooMuch",
  "0xb39e1e6e": "ControllerDisabled",
  "0xb3512b0c": "InvalidShortString",
  "0xb53a01cc": "E_OutstandingDebt",
  "0xbe4dab5d": "E_DeploymentFailed",
  "0xc9e70637": "E_BadAssetReceiver",
  "0xca0985cf": "E_ZeroShares",
  "0xcf479181": "InsufficientBalance",
  "0xcf4d8f28": "E_BadFee",
  "0xd0ccf7a0": "E_NotHookTarget",
  "0xd36283e7": "E_LTVLiquidation",
  "0xd59cc978": "E_ZeroConversionPrice",
  "0xd6bda275": "FailedCall",
  "0xd78bce0c": "ECDSAInvalidSignatureS",
  "0xdac9cb7d": "E_InsufficientDebt",
  "0xe450d38c": "ERC20InsufficientBalance",
  "0xe602df05": "ERC20InvalidApprover",
  "0xea8e4eb5": "NotAuthorized",
  "0xec442f05": "ERC20InvalidReceiver",
  "0xf077d877": "E_InsufficientCash",
  "0xf0991feb": "E_CheckUnauthorized",
  "0xf2fbfb2d": "E_SelfTransfer",
  "0xf645eedf": "ECDSAInvalidSignature",
  "0xfb8f41b2": "ERC20InsufficientAllowance",
  "0xfce698f7": "ECDSAInvalidSignatureLength",
  "0xfea48513": "E_NotSupported",
  "0x305a27a9": "StringTooLong"
}
